/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
//import config from '../config/routes.config.json';
import { routes } from '../config/routes.config';
export interface IRoutesMethods extends IPluginMethodMap {
  getRoutes(args: any): Promise<any>;
}

export class RoutesService implements IAgentPlugin {
  readonly methods: IRoutesMethods;

  constructor() {
    this.methods = {
      getRoutes: this.getRoutes.bind(this),
    };
  }

  async getRoutes(args: any) {
    return {
      ...(routes || {}),
    };
  }
}
